<template>
  <div class="mb-primary col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <h5 class="mb-3">{{ $t("Inicios de sesión en el sistema") }}</h5>
    <app-table :id="tableId" :options="options" @action="getListAction" />
    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      modal-id="modal-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Finalizar jornada y cerrar la sessión?"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../../../resources/js/core/helpers/CoreLibrary";
import * as actions from "../../apiUrl";
import { TableHelpers } from "./TableHelpers";

export default {
  name: "default-filter",
  mixins: [TableHelpers],
  extends: CoreLibrary,
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "audit-session-table",
      rowData: {},

    options: {
        name: "",
        url: `${actions.SESSION_AUDIT}/index-th`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("FINALIZAR JORNADA"),
            icon: "log-out",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "modal-delete",
          },
        ],
       filters: [
          {
            title: this.$t("Filtrar por fechas"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days"],
          },
        ],
        showFilter: true,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: false,
        orderBy: "desc",
        actionType: "default",
      },

      
    };
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("FINALIZAR JORNADA")) {
          if(this.rowData.session_end != null){
             this.$toastr.e(this.$t("Esta sesión ya se encuentra cerrada"));
          }else{
              this.openDeleteModal();
          }
        
      } 
    },

    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      let url = `${actions.SESSION_AUDIT}/session/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#modal-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(this.$t("Sesión finalizada con exito"));
          window.location = '/admin/log-out';
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
          this.searchAndSelectFilterOptions();
        });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.SESSION_AUDIT+'-th/all-names').then((response) => {
        this.options.filters.push({
          title: this.$t("Filtrar por nombre"),
          type: "drop-down-filter",
          key: "select",
          option: ([] = response.data.map((name) => {
            return {
              id: name.id,
              value: name.name,
            };
          })),
        });
      });
    },
  },
};
</script>
